class FilterPersistenceService {
    constructor() {
        this.storagePrefix = 'jxb_filter_settings_';
    }

    /**
     * Save filter settings for a specific page
     * @param {string} pageName - The name of the page (e.g., 'parts', 'assemblies')
     * @param {object} settings - The filter settings to save
     */
    saveFilterSettings(pageName, settings) {
        try {
            const key = this.storagePrefix + pageName.toLowerCase();
            sessionStorage.setItem(key, JSON.stringify(settings));
        } catch (error) {
            console.warn('Failed to save filter settings:', error);
        }
    }

    /**
     * Load filter settings for a specific page
     * @param {string} pageName - The name of the page (e.g., 'parts', 'assemblies')
     * @returns {object|null} - The saved filter settings or null if none exist
     */
    loadFilterSettings(pageName) {
        try {
            const key = this.storagePrefix + pageName.toLowerCase();
            const saved = sessionStorage.getItem(key);
            return saved ? JSON.parse(saved) : null;
        } catch (error) {
            console.warn('Failed to load filter settings:', error);
            return null;
        }
    }

    /**
     * Clear filter settings for a specific page
     * @param {string} pageName - The name of the page
     */
    clearFilterSettings(pageName) {
        try {
            const key = this.storagePrefix + pageName.toLowerCase();
            sessionStorage.removeItem(key);
        } catch (error) {
            console.warn('Failed to clear filter settings:', error);
        }
    }

    /**
     * Clear all filter settings for all pages
     */
    clearAllFilterSettings() {
        try {
            const keys = Object.keys(sessionStorage);
            keys.forEach(key => {
                if (key.startsWith(this.storagePrefix)) {
                    sessionStorage.removeItem(key);
                }
            });
        } catch (error) {
            console.warn('Failed to clear all filter settings:', error);
        }
    }
}

// Export as singleton
export const filterPersistenceService = new FilterPersistenceService(); 